import { application } from "./application"

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import DatetimeController from "./datetime_controller"
application.register("datetime", DatetimeController)

import LocationsStepController from "./locations_step_controller"
application.register("locations-step", LocationsStepController)

import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import ResendController from "./resend_controller"
application.register("resend", ResendController)

import StatusIconController from "./status_icon_controller"
application.register("status-icon", StatusIconController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)
